// src/components/Dashboard/AdminDashboard/AdminHeader.js
import React from 'react';

const AdminHeader = () => {
  return (
    <header style={{ background: 'black', color: 'yellow', padding: '1rem', textAlign: 'center' }}>
      <h1>Admin Dashboard</h1>
    </header>
  );
};

export default AdminHeader;
